import { render, staticRenderFns } from "./datepicker.vue?vue&type=template&id=36999708&scoped=true"
import script from "./datepicker.vue?vue&type=script&lang=js"
export * from "./datepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36999708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/luxury_dreams_production/releases/20261103171319/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36999708')) {
      api.createRecord('36999708', component.options)
    } else {
      api.reload('36999708', component.options)
    }
    module.hot.accept("./datepicker.vue?vue&type=template&id=36999708&scoped=true", function () {
      api.rerender('36999708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/booking/datepicker.vue"
export default component.exports